<template>
  <section class="service-center container">
    <div class="row">
      <ServiceCenterCard v-for="card in serviceCenter.cards" :card="card" :key="card.id" />
    </div>
  </section>
</template>

<script>
import ServiceCenterCard from './ServiceCenterCard.vue';

export default {
  components: { ServiceCenterCard },
  props: {
    serviceCenter: {
      cards: Array
    }
  }
}
</script>